import axios from 'axios'
import request from '@/utils/request'
import qs from 'qs'
import { isMobile } from '@/utils/validate'

export function pay (params, type) {
  return request({
    method: 'get',
    params: {
      r: isMobile() ? (type === 'wx' ? 'pay/wx-h5' : type === 'apple' ? 'pay/apple' : 'pay/alipay-h5') : (type === 'wx' ? 'pay/wx-qrcode' : 'pay/alipay-qrcode'),
      // r: type === 'wx' ? 'pay/wx-h5' : type === 'apple' ? 'pay/apple' : 'pay/alipay-h5',
      ...params
    }
  })
}

export function wxJsPayNew (params) {
  return request({
    method: 'get',
    params: {
      r: 'pay/wx-gzh',
      ...params
    }
  })
}

// export function checkOrder (params) {
//   return axios({
//     url: `//pay.${theme[store.getters.init.ui_type].gameName}.com/api/h5/query_order.php`,
//     method: 'get',
//     params: {
//       imei: store.getters.idfa,
//       ...params
//     }
//   })
// }

export function paySwitch (params) {
  return axios({
    url: `//face.693975.com/mpsw/pgZt.php`,
    method: 'post',
    data: qs.stringify(params)
  })
}

export function checkOrderStatus (params) {
  return request({
    method: 'get',
    params: {
      r: 'pay/check-order-status',
      ...params
    }
  })
}

export function getAgreementUrl (params) {
  return axios({
    url: `//face.693975.com/api/index.php`,
    method: 'get',
    params: {
      c: 'Agreement',
      a: 'getAgreementUrl',
      ...params
    }
  })
}
